export default "__VITE_ASSET__CXnitXnL__"